module.exports = __webpack_public_path__ + "static/redfoot-c835b01b33741d826481538e6ed0c1aa.svg";